import { joiResolver } from "@hookform/resolvers/joi";
import axios from "axios";
import Joi from "joi";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import BusinessHourForm from "src/components/forms/BusinessHourForm";
import CountryForm from "src/components/forms/CountryForm";
import InputForm from "src/components/forms/InputForm";
import SwipetypeForm from "src/components/forms/SwipetypeForm";
import TagSelectorForm from "src/components/forms/TagSelectorForm";
import TextareaForm from "src/components/forms/TextareaForm";
import OSMap from "src/components/OSMap";
import Title from "src/components/Title";
import API from "src/services/api";
import { asArray, asText } from "src/utils/tableFormatter";

const SwipeAddEditSite = () => {
  // Parameter swipe_id aus URL auslesen
  const { swipe_id } = useParams();
  const navigate = useNavigate();

  // Validierungsschema
  const schema = Joi.object({
    swipetype_id: Joi.string().required(),
    name: Joi.string().min(0).max(255),
    street: Joi.string().min(0).max(255),
    street_no: Joi.string().min(0).max(20),
    postcode: Joi.string().min(0).max(11),
    city: Joi.string().min(0).max(255),
    country: Joi.string().required(),
    phone: Joi.string().min(0).max(255),
    email: Joi.string().min(0).max(255),
    website: Joi.string().min(0).max(255),
    facebook_url: Joi.string().min(0).max(255),
    instagram_url: Joi.string().min(0).max(255),
    twitter_url: Joi.string().min(0).max(255),
    tripadvisor_url: Joi.string().min(0).max(255),
    zefix_id: Joi.string().min(0).max(255),
    zefix_name: Joi.string().min(0).max(255),
    tripadvisor_id: Joi.string().min(0).max(255),
    latitude: Joi.number().required(),
    longitude: Joi.number().required(),
    description: Joi.string().min(0).max(350),
    tags: Joi.array(),
    business_hours: Joi.array(),
  });

  const {
    reset,
    handleSubmit,
    register,
    watch,
    control,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(schema),
    defaultValues: {
      tags: [],
      business_hours: [],
    },
  });

  const loadData = async () => {
    const res = await API.getSwipe(swipe_id);
    if (res.status === true) {
      reset({
        swipetype_id: asText(res.data?.swipetype_id),
        name: asText(res.data?.name),
        street: asText(res.data?.street),
        street_no: asText(res.data?.street_no),
        postcode: asText(res.data?.postcode),
        city: asText(res.data?.city),
        country: asText(res.data?.country),
        phone: asText(res.data?.phone),
        email: asText(res.data?.email),
        website: asText(res.data?.website),
        facebook_url: asText(res.data?.facebook_url),
        instagram_url: asText(res.data?.instagram_url),
        twitter_url: asText(res.data?.twitter_url),
        tripadvisor_url: asText(res.data?.tripadvisor_url),
        zefix_id: asText(res.data?.zefix_id),
        zefix_name: asText(res.data?.zefix_name),
        tripadvisor_id: asText(res.data?.tripadvisor_id),
        latitude: res.data?.latitude ?? "",
        longitude: res.data?.longitude ?? "",
        description: res.data?.description ?? "",
        tags: asArray(res.data?.tags)
          .map((item) => item?.id)
          .filter((id) => id != null),
        business_hours: asArray(res.data?.business_hours),
      });
    }
  };
  // Load notes when component is rendered the first time
  useEffect(() => {
    if (swipe_id) {
      loadData();
    }
  }, [swipe_id]);

  const lat = watch("latitude");
  const long = watch("longitude");
  const mapLat = Number(lat);
  const mapLong = Number(long);

  const onSubmit = async (formData) => {
    let result;
    if (swipe_id) {
      result = await API.updateSwipe(swipe_id, formData);
    } else {
      result = await API.createSwipe(formData);
    }

    console.log("result", result);

    if (result.status === true && result.data.id) {
      console.log("ok");
      // Redirect
      navigate(`/swipe/${result.data.id}`);
    } else {
      console.log("error");
      // Error
    }
  };

  const loadOSMAddress = async () => {
    await axios
      .get(
        `https://nominatim.openstreetmap.org/reverse?lat=${getValues(
          "latitude",
        )}&lon=${getValues("longitude")}&format=json`,
        {
          withCredentials: false,
        },
      )
      .then((res) => {
        console.log("RESS", res.data.address);
        if (res.data?.address) {
          console.log("OK");

          if (res.data.address.locality) {
            setValue("street", res.data.address.locality);
          }

          if (res.data.address.road) {
            setValue("street", res.data.address.road);
          }
          if (res.data.address.house_number) {
            setValue("street_no", res.data.address.house_number);
          }

          if (res.data.address.village) {
            setValue("city", res.data.address.village);
          }
          if (res.data.address.town) {
            setValue("city", res.data.address.town);
          }

          if (res.data.address.city) {
            setValue("city", res.data.address.city);
          }
          if (res.data.address.postcode) {
            setValue("postcode", res.data.address.postcode);
          }
        }
      })
      .catch((error) => {
        console.log("Error", error.message, error);
      });
  };

  const loadOSMCoordinates = async () => {
    const address = `${getValues("street")} ${getValues(
      "street_no",
    )}, ${getValues("postcode")} ${getValues("city")}`;
    await axios
      .get(
        `https://nominatim.openstreetmap.org/search?q=${encodeURI(
          address,
        )}&format=json`,
        {
          withCredentials: false,
        },
      )
      .then((res) => {
        if (res && res.data) {
          if (res.data.length > 0) {
            if (res.data[0].lat) {
              setValue("latitude", res.data[0].lat);
            }
            if (res.data[0].lon) {
              setValue("longitude", res.data[0].lon);
            }
          }
        }

        console.log(res);
      })
      .catch((error) => {
        console.log("Error", error.message, error);
      });
  };

  console.log("Error", errors);
  console.log("values", watch());

  return (
    <Row>
      <Col>
        <Title>Swipe {swipe_id ? "bearbeiten" : "erstellen"}</Title>
        <Form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
          <Row>
            <Col>
              <Row>
                <Col>
                  <SwipetypeForm
                    id="swipetype_id"
                    label="Swipe-Typ"
                    control={control}
                    errors={errors}
                  />

                  <InputForm
                    id="name"
                    label="Name"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputForm
                    id="street"
                    label="Strasse"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="street_no"
                    label="Strassennummer"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputForm
                    id="postcode"
                    label="PLZ"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="city"
                    label="Stadt"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <CountryForm
                    id="country"
                    label="Land"
                    control={control}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputForm
                    id="phone"
                    label="Telefon"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="email"
                    label="E-Mail"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="website"
                    label="Webseite"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputForm
                    id="zefix_id"
                    label="Zefix ID"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="zefix_name"
                    label="Zefix Name"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="tripadvisor_id"
                    label="Tripadvisor ID"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="facebook_url"
                    label="Facebook URL"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="instagram_url"
                    label="Instagram URL"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="twitter_url"
                    label="Twitter URL"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="tripadvisor_url"
                    label="Tripadvisor URL"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <TextareaForm
                  id="description"
                  label="Beschreibung"
                  register={register}
                  errors={errors}
                />
              </Row>
            </Col>
            <Col>
              <Row>
                <Col>
                  <Button onClick={() => loadOSMCoordinates()}>
                    Position laden
                  </Button>
                  <Button onClick={() => loadOSMAddress()}>
                    Adresse laden
                  </Button>
                </Col>
                <Col>
                  <InputForm
                    id="latitude"
                    label="Latitude Name"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col>
                  <InputForm
                    id="longitude"
                    label="Longitude Name"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <OSMap
                    lat={Number.isFinite(mapLat) ? mapLat : 0}
                    long={Number.isFinite(mapLong) ? mapLong : 0}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col>
              <BusinessHourForm
                id="business_hours"
                swipeId={swipe_id}
                setValue={setValue}
                watch={watch}
              />
            </Col>
            <Col>
              <h2>Tags</h2>
              <TagSelectorForm
                id="tags"
                control={control}
                setValue={setValue}
                watch={watch}
                swipetype_id={getValues("swipetype_id")}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                variant="warning"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Speichern
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default SwipeAddEditSite;
